const Menu =  [
    { header: 'level : DPW' },
    {
        path    : '/',
        title   : 'Dashboard',    
        name    : 'dashboard',  
        icon    : 'fa-dashboard', 
        meta    : {breadcrumb:false}
    },                   
    { title : 'Input By Form', icon:'devices', name : 'hitung', meta:{breadcrumbs:false}},
    { title : 'Input By Excel', icon:'subtitles', name : 'hitung/byexcel'},
    //{ title : 'KPU Match', name: 'matching/explore', icon:'settings_input_component', meta:{breadcrumbs:false}},
    { title : 'Kesalahan', name: 'analisis', icon:'whatshot', meta:{breadcrumbs:false}},
    { title : 'Report', name: 'report', icon:'assignment'},
    {
        title: 'Saksi/Child',
        name : 'saksi',
        icon : 'contacts',
        meta : {breadcrumb:false}
    },
    
    
    //NON MENU
    { title : 'Provinsi', name: 'pages/home',visible: false},
    { group: 'dashboard',
      visible: false,
      items:[
        { title : 'Explore', name: 'explore', meta:{breadcrumbs:false} },
        { title : 'Live', name: 'live', meta:{breadcrumbs:false, public:true} },
      ]
    },
    { group: 'hitung',
      visible: false,
      items:[
        { title : 'Form Suara', name: 'form' },
        { title : 'View Suara', name: 'view' },
      ]
    },
    { group: 'analisis',
      visible: false,
      items:[
        { title : 'Form Suara', name: 'form' },
        { title : 'View Suara', name: 'view' },
      ]
    },
    { group: 'report',
      visible: false,
      items:[
        { title : 'C1', name: 'c1' },
        { title : 'D1', name: 'd1' },
        { title : 'DA1', name: 'da1' },
        { title : 'DB1', name: 'db1' },
        { title : 'DC1', name: 'dc1' },
      ]
    },
    { group: 'profile',
      visible: false,
      items:[
        { title : 'Profile', meta:{breadcrumbs:false} },
        { title : 'Update Profile', name: 'form' },        
      ]
    },
    { group: 'saksi',
      visible: false,
      items:[
        { title : 'Saksi/Child', name: 'form' },        
      ]
    },
    
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
